<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="类型筛选">
          <el-button-group>
            <el-button @click="changeTypeFunc('')">不限</el-button>
            <el-button :type="formInline.grade_id == item.grade_id ? 'primary' : ''" plain v-for="(item, index) in type" :key="index" @click="changeTypeFunc(item.grade_id)">{{item.name}}</el-button>
          </el-button-group>
        </el-form-item>
        <br>
        <el-form-item label="手机号">
          <el-input v-model="formInline.mobile" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input v-model="formInline.user_id" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择">
            <el-option label="不限" value=""></el-option>
            <el-option label="有效" value="1"></el-option>
            <el-option label="无效" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="添加时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" clearable type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="d-s-c">
      <el-button size="small" type="primary" @click="openPopup('add')" icon="el-icon-plus">添加</el-button>
      <el-button size="small" type="success" @click="openPopup('upload')" icon="el-icon-plus">导入</el-button>
    </div>

    <!--内容-->
    <div class="product-content mt10">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange">
          <el-table-column prop="id" label="ID" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="mobile" label="手机号码" width="120"></el-table-column>
          <el-table-column prop="grade_id" label="类型" align="center">
              <template slot-scope="scope" v-if="type[scope.row.grade_id]">
              {{ type[scope.row.grade_id].name }}
              </template>
          </el-table-column>
          <!-- <el-table-column prop="user_id" label="用户" width="120"></el-table-column> -->
          <el-table-column prop="user.nickName" label="用户" width="200">
            <template slot-scope="scope" v-if="scope.row.user">
              <p>用户ID：{{scope.row.user.user_id}}</p>
              <p>昵称：{{scope.row.user.nickName}}</p>
              <p v-if="scope.row.user.mobile">手机：{{scope.row.user.mobile}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="use_time" label="绑定时间" width="140" sortable="custom"></el-table-column>
          
          <el-table-column prop="create_time" label="添加时间" width="140" sortable="custom"></el-table-column>
          <el-table-column prop="status" label="状态" width="60">
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.status">有效</span>
              <span class="gray9" v-else>无效</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="操作" width="130" align="center">
            <template slot-scope="scope">
              <el-button @click="openPopup('edit', scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--添加-->
    <Add v-if="show_popup['add']" :open_add="show_popup['add']" @closeDialog="closeDialogFunc($event, 'add')"></Add>

    <!--编辑-->
    <Edit v-if="show_popup['edit']" :open_edit="show_popup['edit']" :selectModel="selectModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

    <!--导入-->
    <Upload v-if="show_popup['upload']" :open_upload="show_popup['upload']" :selectModel="selectModel" @closeDialog="closeDialogFunc($event, 'upload')"></Upload>
  </div>
</template>

<script>
  import ImportUserApi from '@/api/study/import_user.js';
  import Edit from './part/Edit.vue';
  import Add from './part/Add';
  import Upload from './part/Upload';
  import { deepClone } from '@/utils/base.js';
  export default {
    components: {
      Edit,
      Add,
      Upload
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          mobile: '',
          user_id: '',
          grade_id: '',
          create_time: '',
          use_time: '',
          status: ''
        },
        /*时间*/
        create_time: '',
        /*等级*/
        grade:[],
        type: [],
        /*当前父集ID*/
        parentsVal: [],
        /*弹窗*/
        show_popup: {
          add: false,
          edit: false,
          upload: false,
        },
        selectModel: []
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formInline, params);

      // 默认
      let grade_id = this.$db.getRouteField(this, 'grade_id');
      if (grade_id) this.formInline.grade_id = grade_id;

      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*选择分类*/
      handleChange(e) {
        console.log(e);
      },
      /*跳转订单详情*/
      gotoPage(row) {
        let self = this;
        this.$router.push({
          path: '/order/order/detail',
          query: {
            order_id: row.order_id
          }
        });
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;
        ImportUserApi.getList(Params, true).then(res => {
          let data = res.data;
          self.loading = false;
          self.tableData = data.list.data;
          self.type = data.type;
          self.totalDataNumber = data.list.total;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*查找父集id*/
    findParentsID(list){
      let flag=false;
      for(let i=0;i<list.length;i++){
        let item=list[i];
        if(item.category_id==this.formData.category_id){
          this.parentsVal.unshift(item.category_id);
          flag=true;
          break;
        }else{
          let children=item.children;
          if(typeof children!='undefined'&&children.length>0){
              if(this.findParentsID(children)){
                this.parentsVal.unshift(item.category_id);
                flag=true;
                break;
              }
          }
        }
      }
      return flag;
    },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getTableList();
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getTableList();
      },

      /*删除用户*/
      deleteClick(row) {
        let self = this;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            self.loading = true;
            ImportUserApi.del({id: row.id},true)
              .then(data => {
                if (data.code == 1) {
                  self.loading = false;
                  self.$message({
                    message: data.msg,
                    type: 'success'
                  });
                  self.getTableList();
                }
              })
              .catch(error => {
                self.loading = false;
              });
          })
          .catch(() => {});
      },

      /*打开弹窗*/
      openPopup(name, item){
        this.show_popup[name] = true;
        if(item&&typeof(item)!='undefined') this.selectModel = item;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.show_popup[f] = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      },

      /*选择类型*/
      changeTypeFunc(e){
        this.formInline.grade_id = e;
        this.$db.setRoute(this, {'grade_id': e});
        this.getTableList();
      },
    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/study/importuser/user/Index.vue